import {
  composeValidators,
  textMaxLengthValidator,
  textValidator,
} from 'app/components/Form/utils/validators';

import Inventory from '../../../../../i18n/Inventory';
import {
  availableQuantityAndTotalQuantityValidator,
  itemInStockValidator,
} from '../../../utils/rules';

export const ConsumedReason = 'Consumed';
export const DamagedReason = 'Damaged';
export const DonatedReason = 'Donated';
export const SoldReason = 'Sold';
export const OtherReason = 'Other';

export const REASON_ITEMS = [
  {
    label: ConsumedReason,
    value: ConsumedReason,
  },
  {
    label: DamagedReason,
    value: DamagedReason,
  },
  {
    label: DonatedReason,
    value: DonatedReason,
  },
  {
    label: SoldReason,
    value: SoldReason,
  },
  {
    label: OtherReason,
    value: OtherReason,
  },
];

export const REMOVE_FORM_RULES = {
  itemInStockSearch: {
    validate: textValidator('PROCURE_8012'),
  },
  itemInStock: itemInStockValidator,
  sourceId: {
    validate: textValidator('PROCURE_3016'),
  },
  sourceLocationId: {
    validate: textValidator('PROCURE_3017'),
  },
  reason: {
    validate: textValidator('PROCURE_8005'),
  },
  reasonMessage: {
    validate: composeValidators(
      textValidator('PROCURE_8006'),
      textMaxLengthValidator('PROCURE_8007', 32),
    ),
  },
  quantity: availableQuantityAndTotalQuantityValidator,
};
